import * as React from 'react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

export default class SpinnerBasicExample extends React.Component {
    render() {
        const label = this.props.label ? (
            <div style={{ textAlign: 'center' }}>
                {this.props.label}
            </div>
        ) : "";

        return (
            <div className="ms-BasicSpinnersExample">
                <Spinner
                    size={SpinnerSize.large}
                    label={label}
                    ariaLive="assertive"
                    labelPosition="top"
                />
            </div>
        );
    }
}